<template>
  <div ref="total" class="ll-app-fixed-tool-bar">
    <div
      class="ll-app-fixed-tool-bar__start"
      :style="{ '--total-width': `${totalWidth}px`, '--tool-bar-width': `${toolBarWidth}px` }"
    >
      <slot />
    </div>
    <div ref="toolBar" class="tool-bar">
      <div
        v-if="_currentCompanyName"
        class="action-item ll-app-fixed-tool-bar__name-wrap"
      >
        <p ref="toolBarName" class="ll-app-fixed-tool-bar__name">{{ _currentCompanyName }}</p>
        <div v-if="isEllipsis" class="ll-app-fixed-tool-bar__name-tooltip">{{ _currentCompanyName }}</div>
      </div>
      <div v-if="_isEsgoalContactEnabled" class="action-item">
        <HelpTool />
      </div>
      <div class="action-item">
        <RemindTool
          url="/notifications"
          :isNotice="_currentUser.unread_notification_count?true:false"
          @remind-click="$_remindToolClick($event)"
        />
      </div>
      <div class="action-item">
        <UserAvatar
          ref="UserAvatar"
          :image="_userImage"
          :item-list="userToolList"
          @btn-click="$_userToolClick($event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/__config";
import notificationService from "@/service/api/v1/notification";
import scope from "@/service/api/v1/scope";
export default {
  name: "LlAppFixedToolBar",
  data() {
    return {
      userToolList: [
        {
          text: this.$t("編輯個人資料"),
          value: "edit",
        },
        {
          text: this.$t("登出"),
          value: "signout",
        },
      ],
      remindList: [
        {
          title: "恭喜你的帳號已成功成為集團帳號，點此新增更多帳號來來來來來",
          date: "2020-04-10",
          type: "icon-settings-outline",
          hasDot: true,
        },
      ],
      toolBarWidth: '',
      totalWidth: '',
      isEllipsis: false,
    };
  },
  computed: {
    _isEsgoalContactEnabled() {
      return config.build.esgoalContact;
    },
    _currentCompanyName() {
      return this.$store.state.app.factory
        ? this.$store.state.app.factory.name
        : null
    },
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _userImage() {
      if (!this._currentUser) return "";
      return this._currentUser.avatar;
    },
    _currentNotification() {
      const _notionfication = this.$store.state.notification.notificationList;
      if (_notionfication.length === 0) {
        return [];
      } else {
        return _notionfication;
      }
    },
  },
  mounted() {
    this.$_getToolBarWidth();
    this.$_getTotalWidth();
    this.$_getToolBarNameWidth();
  },
  created() {
    window.addEventListener("resize", this.$_getToolBarWidth);
    window.addEventListener("resize", this.$_getTotalWidth);
    window.addEventListener("resize", this.$_getToolBarNameWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_getToolBarWidth);
    window.removeEventListener("resize", this.$_getTotalWidth);
    window.removeEventListener("resize", this.$_getToolBarNameWidth);
  },
  methods: {
    $_userToolClick($event) {
      this.$refs.UserAvatar.$_dropdownClose();
      if ($event === "edit") {
        if (this.$route.name === 'setting') {
          if (this.$route.query.tab === 'account') return;
          else this.$router.replace({query: {
            ...this.query,
            tab: 'account',
          }});
        } else {
          this.$router.push({
            path: `/factory/${this._currentFactoryId}/setting-main`,
            query: {
              tab: 'account',
            },
          });
        }
      } else if ($event === "signout") {
        this.$_signOut();
      }
    },
    $_signOut() {
      this.$router.push("/signout");
    },
    async $_remindToolClick($event) {
      //判斷是否有權限可以點擊
      //~判斷點擊事件名稱
      const actionName = notificationService.$_getNotificationClickName($event);
      //~判斷是否有權限進入該頁面
      const is_scope = scope.$_invalidPopupOpen(actionName, "action");
      if (!is_scope) {
        return;
      }
      //讀取通知內容
      await notificationService.read($event.id);
      let notice = $event.data;
      //導向頁面
      const routeUrl = this.$router.resolve(
        notificationService.$_getRoutePath(notice)
      );
      window.open(routeUrl.href, "_blank");
    },
    $_notifyClick(notify) {
      if (notify.factory_id) {
        localStorage.removeItem("organizationId");
        localStorage.setItem("factoryId", notify.factory_id);
      } else if (notify.organization_id) {
        localStorage.setItem("organizationId", notify.organization_id);
        localStorage.removeItem("factoryId");
      }
    },
    $_getToolBarWidth() {
      setTimeout(() => {
        this.$nextTick(() => {
          const toolBar = this.$refs.toolBar;
          this.toolBarWidth = toolBar ? toolBar.offsetWidth : '';
        })
      }, 0);
    },
    $_getTotalWidth() {
      setTimeout(() => {
        this.$nextTick(() => {
          const total = this.$refs.total;
          this.totalWidth = total ? total.clientWidth - 43 : '';
        })
      }, 0);
    },
    $_getToolBarNameWidth() {
      setTimeout(() => {
        this.$nextTick(() => {
          const toolBarName = this.$refs.toolBarName;
          this.isEllipsis = toolBarName ? toolBarName.offsetWidth >= 120 : false;
        })
      }, 0);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-app-fixed-tool-bar";
</style>
